import { useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { Plus, Minus } from '@/icons';
import { cn } from '@/lib/cn';

type Props = {
  question: string;
  answer: string;
};

export function FaqItem({ question, answer }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-border">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={cn(
          'flex w-full items-start justify-between gap-6 py-6 text-left transition-colors',
          'hover:text-accent focus-visible:outline-2 focus-visible:outline-accent focus-visible:outline-offset-4',
        )}
        aria-expanded={open}
      >
        <span className="font-sans text-lg md:text-xl font-medium pr-4">{question}</span>
        <span aria-hidden className="shrink-0 text-accent mt-1">
          {open ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden"
          >
            <p className="pb-6 pr-10 text-ink-secondary leading-relaxed max-w-prose">{answer}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
